<mat-dialog-content fxLayout="column">
    <p [style.margin-bottom]="externalTemplate ? 0 :''" [innerHtml]='message | safeHtml'></p>
    <ng-container [ngTemplateOutlet]="externalTemplate? externalTemplate : ''" [ngTemplateOutletContext]="externalTemplateContext"></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="center" style="gap: 8px;">
    <button *ngIf="!isDisableNoButton" mat-stroked-button mat-dialog-close>{{falseTitle}}</button>
    <button *ngIf="alternateTitle!= null" mat-raised-button color="warn" [mat-dialog-close]="alternateReturnData" [disabled]="isDisabled"
        cdkFocusInitial>{{alternateTitle}}</button>
    <button mat-raised-button [color]="yesColor" *ngIf="yesTitle != 'DISABLED'" [mat-dialog-close]="true" [disabled]="isDisabled" (click)="copyToClipboard()">{{yesTitle}}</button>
</mat-dialog-actions>